import { GetGlobalUserSurveyResponse } from "../../models/globalUserSurvey"
import {
    CreateSurveyRequest,
    CreateSurveyResponse,
    DeleteSurveyResponse,
    GetSurveysRequest,
    GetSurveysResponse,
    UpdateSurveyRequest,
    UpdateSurveyResponse
} from "../../models/survey"
import { queryApi } from "../api"
import { onQueryStartedErrorHandler } from "../utility/error"
import { SURVEY_API_ERROR_MESSAGES } from "../constants/surveys.const"
import { surveysTag } from "../tags"

const invalidateTagsFn = (_: unknown, __: unknown, { projectId }: { projectId: string }) => [
    { type: surveysTag, projectId }
]

export const surveysApiController = queryApi.injectEndpoints({
    endpoints: build => {
        return {
            getGlobalUserSurvey: build.query<GetGlobalUserSurveyResponse, void>({
                query: () => ({
                    url: "/survey/default-project-survey",
                    method: "GET"
                })
            }),
            getSurveys: build.query<GetSurveysResponse, GetSurveysRequest>({
                query: ({ projectId, body = { PageFrom: 0, PageSize: 1000 } }) => ({
                    url: `${projectId}/survey/page`,
                    method: "POST",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SURVEY_API_ERROR_MESSAGES.GET),
                providesTags(_, __, { projectId }) {
                    return [{ type: surveysTag, projectId }]
                }
            }),
            createSurvey: build.mutation<CreateSurveyResponse, CreateSurveyRequest>({
                query: ({ projectId, body }) => ({
                    url: `${projectId}/survey`,
                    method: "POST",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SURVEY_API_ERROR_MESSAGES.CREATE),
                invalidatesTags: invalidateTagsFn
            }),
            updateSurvey: build.mutation<UpdateSurveyResponse, UpdateSurveyRequest>({
                query: ({ projectId, surveyId, body }) => ({
                    url: `${projectId}/survey/${surveyId}`,
                    method: "PUT",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SURVEY_API_ERROR_MESSAGES.UPDATE),
                invalidatesTags: invalidateTagsFn
            }),
            deleteSurvey: build.mutation<DeleteSurveyResponse, { projectId: string; surveyId: string }>({
                query: ({ projectId, surveyId }) => ({
                    url: `${projectId}/survey/${surveyId}`,
                    method: "DELETE"
                }),
                onQueryStarted: onQueryStartedErrorHandler(SURVEY_API_ERROR_MESSAGES.DELETE),
                invalidatesTags: invalidateTagsFn
            })
        }
    }
})

export const {
    useLazyGetGlobalUserSurveyQuery,
    useGetSurveysQuery,
    useCreateSurveyMutation,
    useUpdateSurveyMutation,
    useDeleteSurveyMutation
} = surveysApiController
